import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export const ShareButton = () => {
  const handleShare = async () => {
    const url = window.location.origin;
    const shareData = {
      title: "Centro Auto Pontedera · Noleggio Auto",
      text: "Noleggia un'auto a Pontedera in modo semplice e veloce con Centro Auto Pontedera! 🚗",
      url,
    };
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch (e) {
        if (e && e.name === "AbortError") return; // user cancelled
      }
    }
    // Fallback (desktop): copy the link
    try {
      await navigator.clipboard.writeText(`${shareData.text} ${url}`);
      toast.success("Link copiato! Incollalo in WhatsApp, email o dove preferisci.");
    } catch (e) {
      window.open(`https://wa.me/?text=${encodeURIComponent(`${shareData.text} ${url}`)}`, "_blank");
    }
  };

  return (
    <Button
      onClick={handleShare}
      variant="outline"
      className="rounded-full border-[#E63946]/40 text-foreground hover:bg-[#E63946]/10 px-4 font-semibold gap-2"
      data-testid="share-app-btn"
      title="Invia a un amico"
    >
      <Share2 className="w-4 h-4" />
      <span className="hidden sm:inline">Invita un amico</span>
    </Button>
  );
};
